exports = module.exports = require("../../node_modules/_css-loader@0.27.3@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".doctor5[data-v-3349ae3e]{padding:15px;background-color:#fbf9f9;border-radius:4px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;margin-top:15px}.doctor5 h5[data-v-3349ae3e]{margin:0 0 15px}.doctor5 .img[data-v-3349ae3e]{height:50px;width:50px;border-radius:50%;overflow:hidden}@media screen and (min-width:900px){.doctor5[data-v-3349ae3e]{padding:15px;background-color:#fbf9f9;border-radius:4px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;margin-top:15px}.doctor5 h5[data-v-3349ae3e]{margin:0 0 15px}.doctor5 .img[data-v-3349ae3e]{height:50px;width:50px;border-radius:50%;overflow:hidden}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3349ae3e","scoped":true,"hasInlineConfig":false}!./~/_sass-loader@7.1.0@sass-loader/lib/loader.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/doctor5.vue
// module id = 167
// module chunks = 1